import { GraphQLBoolean, GraphQLObjectType, GraphQLString } from 'graphql';
import { TypeNames } from '../../types';
const TeamInSlackStatusType = new GraphQLObjectType({
  fields: {
    id: {
      type: GraphQLString
    },
    connected: {
      type: GraphQLBoolean
    },
    slackChannelId: {
      type: GraphQLString
    },
    slackChannelName: {
      type: GraphQLString
    },
    usergroupHandle: {
      type: GraphQLString
    }
  },
  name: TypeNames.TeamSlackStatus,
  description: 'Whether the team has opted in to being synced with slack'
});
export default TeamInSlackStatusType;